import React from 'react';
import {
  makeStyles, Container, Grid, Typography, Box, Button,
} from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import getLocalizedUrl from 'utils/getLocalizedUrl';
import { i18n as lang } from 'config/i18n';

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    marginTop: theme.spacing(13),
    paddingBottom: theme.spacing(13),
    [theme.breakpoints.up('lg')]: {
      paddingBottom: theme.spacing(22),
      marginTop: theme.spacing(18),
    },
    [theme.breakpoints.only('sm')]: {
      marginTop: theme.spacing(8),
      paddingBottom: theme.spacing(12),
    },
  },
  title: {
    fontSize: theme.typography.pxToRem(22),
    marginBottom: theme.spacing(0),
    fontFamily: theme.typography.fontFamilySecondary,
    textAlign: 'center',
    fontWeight: 'bold',
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(36),
      marginBottom: theme.spacing(4),
    },
    [theme.breakpoints.up('lg')]: {
      marginBottom: theme.spacing(8),
    },
  },
  txtGrid: {
    marginTop: theme.spacing(4.75),
    [theme.breakpoints.up('lg')]: {
      order: 2,
      marginTop: 0,
    },
  },
  questionsContainer: {
    padding: theme.spacing(0, 0, 5),
    width: 'auto',
    marginLeft: 0,
    textAlign: 'center',
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(0, 0, 8),
    },
  },
  questionTitle: {
    fontSize: theme.typography.pxToRem(24),
    fontWeight: '500',
    [theme.breakpoints.only('sm')]: {
      fontSize: theme.typography.pxToRem(18),
    },
  },
  questionDesc: {
    letterSpacing: theme.typography.pxToRem(0.5),
    lineHeight: theme.typography.pxToRem(24),
    marginTop: theme.spacing(1.5),
    fontSize: theme.typography.pxToRem(16),
    '& a': {
      color: theme.palette.secondary.main,
      fontWeight: 'bold',
      textDecoration: 'none',
    },
  },
  moreAnswers: {
    padding: 0,
    background: 'none !important',
    textDecoration: 'underline',
    marginLeft: 0,
    textAlign: 'center',
    display: 'flex',
  },
}));

const CommercialQuestionsSection = ({ i18n }) => {
  const classes = useStyles();

  const questions = i18n('fe_commercial_questions_component:questions', {
    returnObjects: true,
  });

  return (
    <>
      <Container maxWidth="xl" classes={{ root: classes.mainContainer }}>
        <Typography variant="h2" classes={{ root: classes.title }}>
          {i18n('fe_commercial_questions_component:title')}
        </Typography>

        <Grid container justify="center" alignItems="center" spacing={2}>
          <Grid item xs={12} lg={8} classes={{ root: classes.txtGrid }}>
            {questions.map((question, index) => (
              <Box className={classes.questionsContainer} key={question.q + question.a}>
                <Typography variant="h4" classes={{ root: classes.questionTitle }}>
                  {question.q}
                </Typography>
                {index == 0 ? (
                  <Typography
                    classes={{ root: classes.questionDesc }}
                    dangerouslySetInnerHTML={{
                      __html: i18n('fe_commercial_questions_component:questions.0.a', {
                        er_path: 'https://www.eaglerider.com',
                      }),
                    }}
                  />
                ) : (
                  <Typography classes={{ root: classes.questionDesc }}>{question.a}</Typography>
                )}
              </Box>
            ))}
            <Button
              color="primary"
              classes={{ root: classes.moreAnswers }}
              target="_blank"
              href={getLocalizedUrl('/faqs/eagleshare-commercial-owner', lang.language)}
              endIcon={<ArrowForwardIcon />}
            >
              {i18n('fe_commercial_questions_component:find_more_answers')}
            </Button>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default CommercialQuestionsSection;
